// Pure predicate for "does this issue need a MOVE of an unhoused contact
// into an existing household?" — contact-no-household's `move`
// recommendation had no decide-rail handling at all (dead end: "open the
// record to apply it", even though the record has no household to open
// a merge/move UI from). Same convention as
// household-search-merge-predicate.ts / household-cluster-predicate.ts —
// root-safe, unit-tested from tests/web/ without web/src/api.ts.

export type RecordRef = { kind: string; id: string; label: string };

export interface IssueLike {
  entityKind: string;
  detectorSlug?: string;
  affectedRecords?: RecordRef[];
  recommendation?: { verb: string } | null;
}

export function contactMoveSource(issue: IssueLike): RecordRef | null {
  if (issue.entityKind !== "contact") return null;
  if (issue.recommendation?.verb !== "move") return null;
  const recs = (issue.affectedRecords ?? []).filter(
    (r) => r.kind === "contact",
  );
  return recs.length === 1 ? recs[0]! : null;
}
